"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class Em extends mark_1.Mark {
    constructor() {
        super('em');
    }
}
exports.Em = Em;
//# sourceMappingURL=em.js.map